module.exports = __webpack_public_path__ + "img/Success.40775086.svg";